import { useCallback, useRef, useState } from 'react';

export const usePopoverFocus = (initialState: boolean = false) => {
  const [isOpen, setIsOpen] = useState(initialState);
  const previousFocusRef = useRef<HTMLElement | null>(null);

  const open = useCallback(() => {
    previousFocusRef.current = document.activeElement as HTMLElement;
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  const onExited = useCallback(() => {
    previousFocusRef.current?.focus();
  }, []);

  return {
    isOpen,
    open,
    close,
    onExited
  };
};
